import { getCursor, toDomPrecision, track, useEditor, useSelectionEvents } from '@tldraw/tldraw'

export interface MaskHandlesProps {
  width: number
  height: number
  rotation: number
}

export const MaskHandles = track(({ width, height, rotation }: MaskHandlesProps) => {
  const editor = useEditor()

  const topLeftEvents = useSelectionEvents('top_left')
  const topRightEvents = useSelectionEvents('top_right')
  const bottomRightEvents = useSelectionEvents('bottom_right')
  const bottomLeftEvents = useSelectionEvents('bottom_left')

  const isCoarsePointer = editor.getInstanceState().isCoarsePointer
  const zoom = editor.getZoomLevel()
  const size = 8 / zoom

  const isSmallX = width < size * 4
  const isSmallY = height < size * 4
  const mobileHandleMultiplier = isCoarsePointer ? 1.75 : 1
  const targetSize = (6 / zoom) * mobileHandleMultiplier

  const targetSizeX = (isSmallX ? targetSize / 2 : targetSize) * (mobileHandleMultiplier * 0.75)
  const targetSizeY = (isSmallY ? targetSize / 2 : targetSize) * (mobileHandleMultiplier * 0.75)
  const isDefaultCursor = !editor.getIsMenuOpen() && editor.getInstanceState().cursor.type === 'default'
  const commonStyles = {
    stroke: 'var(--selected-stroke)',
    fill: 'var(--color-background)',
    strokeWidth: 'calc(1.5px* var(--tl-scale))',
  }

  return (
    <svg className="tl-overlays__item">
      <rect
        className="tl-transparent"
        data-testid="selection.target.top-left"
        aria-label="top-left target"
        pointerEvents="all"
        x={toDomPrecision(0 - (isSmallX ? targetSizeX * 2 : targetSizeX * 1.5))}
        y={toDomPrecision(0 - (isSmallY ? targetSizeY * 2 : targetSizeY * 1.5))}
        width={toDomPrecision(targetSizeX * 3)}
        height={toDomPrecision(targetSizeY * 3)}
        style={{
          ...commonStyles,
          cursor: isDefaultCursor ? getCursor('nwse-resize', rotation) : undefined,
        }}
        {...topLeftEvents}
      />
      <rect
        className="tl-transparent"
        data-testid="selection.target.top-right"
        aria-label="top-right target"
        pointerEvents="all"
        x={toDomPrecision(width - (isSmallX ? 0 : targetSizeX * 1.5))}
        y={toDomPrecision(0 - (isSmallY ? targetSizeY * 2 : targetSizeY * 1.5))}
        width={toDomPrecision(targetSizeX * 3)}
        height={toDomPrecision(targetSizeY * 3)}
        style={{
          ...commonStyles,
          cursor: isDefaultCursor ? getCursor('nesw-resize', rotation) : undefined,
        }}
        {...topRightEvents}
      />
      <rect
        className="tl-transparent"
        data-testid="selection.target.bottom-right"
        aria-label="bottom-right target"
        pointerEvents="all"
        x={toDomPrecision(width - (isSmallX ? targetSizeX : targetSizeX * 1.5))}
        y={toDomPrecision(height - (isSmallY ? targetSizeY : targetSizeY * 1.5))}
        width={toDomPrecision(targetSizeX * 3)}
        height={toDomPrecision(targetSizeY * 3)}
        style={{
          ...commonStyles,
          cursor: isDefaultCursor ? getCursor('nwse-resize', rotation) : undefined,
        }}
        {...bottomRightEvents}
      />
      <rect
        className="tl-transparent"
        data-testid="selection.target.bottom-left"
        aria-label="bottom-left target"
        pointerEvents="all"
        x={toDomPrecision(0 - (isSmallX ? targetSizeX * 3 : targetSizeX * 1.5))}
        y={toDomPrecision(height - (isSmallY ? 0 : targetSizeY * 1.5))}
        width={toDomPrecision(targetSizeX * 3)}
        height={toDomPrecision(targetSizeY * 3)}
        style={{
          ...commonStyles,
          cursor: isDefaultCursor ? getCursor('nesw-resize', rotation) : undefined,
        }}
        {...bottomLeftEvents}
      />
    </svg>
  )
})
